import { render } from "./NavBarDatosColaborador.vue?vue&type=template&id=ded7d636&scoped=true"
import script from "./NavBarDatosColaborador.vue?vue&type=script&lang=js"
export * from "./NavBarDatosColaborador.vue?vue&type=script&lang=js"

import "./NavBarDatosColaborador.vue?vue&type=style&index=0&id=ded7d636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded7d636"]])

export default __exports__